export default "__VITE_ASSET__uxibObJY__"